module.exports = __webpack_public_path__ + "img/img_title_group.e94a4349.png";